import Headroom from 'headroom.js';
import State from './State';
import TouchAndMobile from './TouchAndMobile';

let header = document.querySelector('.page-header');

if (header) {
    if (header.classList.contains('headroom')) {
        let offset = header.clientHeight || 0;
        let headr = new Headroom(header, {
            tolerance: 5,
            offset: offset
        });
        headr.init();
    }
}

const settings = {
    namespace: 'mainnav',
    header: '.header-container'
};

new State(settings);
new TouchAndMobile(settings);
